/** @module Specification/CareAndComposition/DataSheetCareInstructionsMatrix */
define([
    "dojo/_base/declare",
    "csi/table/matrix/Path"
], function(declare,PathMatrix) {

    return declare(PathMatrix, {

        /**
         * Get careInstructions
         * @param {Context} ctx
         * @param {QueryResult} qr
         * @param {Spec} c
         * @param {Node} node
         */
        _getRowNodes: function(ctx, qr, c, node) {           
            return ctx.cache.getNodes(ctx.getParent().CareInstructions);
        }

    });
});